module.exports = __webpack_public_path__ + "img/radio_button.d155789b.svg";